import { useState } from "react";
import { TextField, Button, IconButton, InputAdornment } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { login } from "../../../DAL/auth/auth";
import { useAdminContext } from "../../../hooks/UseAdminContext";
import LogoContainer from "./LogoContainer";
import DashboardHeader from "../../headers/DashboardHeader";

export default function LoginForm() {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const { setUserInfo } = useAdminContext();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const loginData = {
      email: inputs.email,
      password: inputs.password,
      type: 1,
    };

    const response = await login(loginData);

    if (response.code === 200) {
      localStorage.setItem("token", response.token);
      localStorage.setItem("user", JSON.stringify(response.user));
      setUserInfo(response.user);
      navigate("/two-step-verification", { state: { is_login: true } });
      setIsLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  return (
    <div className="header-container">
      <DashboardHeader />

      <div className="pageContainer">
        <LogoContainer />
        <div className="form-container">
          <div className="form-content">
            <h1 className="sign-in-title">Sign In</h1>
            <form onSubmit={handleSubmit} className="form">
              <div className="mt-3">
                <TextField
                  fullWidth
                  required
                  label="Email"
                  name="email"
                  type="email"
                  value={inputs.email}
                  onChange={handleChange}
                />
              </div>
              <div className="mt-3">
                <TextField
                  fullWidth
                  required
                  label="Password"
                  name="password"
                  type={passwordVisible ? "text" : "password"}
                  value={inputs.password}
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setPasswordVisible((prev) => !prev)}
                          edge="end"
                        >
                          {passwordVisible ? (
                            <VisibilityOffOutlinedIcon fontSize="small" />
                          ) : (
                            <VisibilityOutlinedIcon fontSize="small" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="forgot-password-container mt-2">
                <div
                  onClick={() => navigate("/two-step-verification-via-forgot")}
                  className="forgot-password-link pointer"
                >
                  Forgot Password?
                </div>
              </div>
              <Button
                type="submit"
                disabled={isLoading}
                variant="contained"
                fullWidth
              >
                {isLoading ? "Loading..." : "Login"}
              </Button>
              <div className="mt-3 text-end">
                <Button
                  className="w-100"
                  onClick={() => navigate("/create-an-account")}
                >
                  Don’t have an account? Sign up
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
